<!-- monaco-editor.component.html -->
<div
  #editorContainer
  class="monaco-editor-container"
  [style.width]="width"
  [style.height]="height"
></div>
